
import { usePaymentStatus } from "./hooks/usePaymentStatus";
import { groupPaymentsByTimeSlot } from "./utils/payment-utils";
import { TimeSlotCard } from "./components/TimeSlotCard";
import { GroupedPayments } from "./types/payment-status";

export const PaymentStatusView = () => {
  const { data: paymentStatuses = [], isLoading, error } = usePaymentStatus();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8 text-red-500">
        Error loading payment records. Please try again later.
      </div>
    );
  }

  const groupedPayments: GroupedPayments = groupPaymentsByTimeSlot(paymentStatuses);

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold mb-6">Payment Status</h2>
      {Object.entries(groupedPayments).length > 0 ? (
        Object.entries(groupedPayments).map(([timeSlotKey, timeSlotData]) => (
          <TimeSlotCard
            key={timeSlotKey}
            timeSlotKey={timeSlotKey}
            timeSlotData={timeSlotData}
          />
        ))
      ) : (
        <div className="text-center py-8 text-gray-500">
          No payment records found
        </div>
      )}
    </div>
  );
};
